import type {Optional} from '@yandex-delivery/types'
import {applySpec, constant, equals, flow, get, ifElse, toUndefined} from '@yandex-delivery/utils'

import type {ItemFiscalization, Product} from 'src/shared/types'

const toVatCodeString: (nds?: number) => string = nds => `vat${nds ? nds : ''}`

const isWithoutNDSOptionSelected: (nds?: number) => boolean = equals(-1)

const toVatCodeIfNotWithoutNDS: (nds?: number) => Optional<string | number> = ifElse(
  isWithoutNDSOptionSelected,
  toUndefined,
  toVatCodeString,
)

const toFiscalization: (product: Product) => ItemFiscalization = applySpec({
  vat_code_str: flow(get('nds'), toVatCodeIfNotWithoutNDS),
  supplier_inn: get('inn'),
  article: get('vendorCode'),
  item_type: constant('product'),
})

export const toFiscalizaitonIfPaymentOnDemand = (
  product: Product,
  isPaymentOnDemand?: boolean,
): Optional<ItemFiscalization> => (isPaymentOnDemand ? toFiscalization(product) : undefined)
